var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4727 13.1998C24.4727 19.2065 19.5977 24.0816 13.5909 24.0816C7.58424 24.0816 2.70923 19.2065 2.70923 13.1998C2.70923 7.19313 7.58424 2.31812 13.5909 2.31812C19.5977 2.31812 24.4727 7.19313 24.4727 13.1998Z",
    stroke: "#292D32",
    strokeWidth: 1.63226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6276 16.6599L14.2543 14.6468C13.6667 14.2985 13.1879 13.4607 13.1879 12.7751V8.3136",
    stroke: "#292D32",
    strokeWidth: 1.63226,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.949af1127367c5ceb50543aac464c044.svg";
export { ForwardRef as ReactComponent };